'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const MerchantLogoImage = require('../.././modules/shared/views/merchants/merchant-logo-image');
const { getButtonUrl } = require('../../modules/support/slug-helper');

function Thumbnail({ item, index, clickNavigation, routes }) {
  const { merchantSlug, destination, merchantName, offerCallout, media } = item;

  const buttonUrl = getButtonUrl({
    routes,
    merchantSlug,
    destination,
  });

  return h(WithI18n, {}, i18n =>
    h(
      'a.navigation-item',
      {
        href: buttonUrl,
        'aria-label': i18n.t('js.modules.shared.PaginationLinkAriaFormat', {
          0: 'carousel',
          1: merchantName,
        }),
        'data-bhc': `carousel-navigation:thumbnail-${merchantName}`,
        title: i18n.t('js.modules.shared.PaginationLinkAriaFormat', {
          0: 'carousel',
          1: merchantName,
        }),
        onClick: event => clickNavigation(event, index),
      },
      h(
        '.navigation-image',
        MerchantLogoImage({
          alt: `${merchantName} - ${offerCallout}`,
          data: media,
          size: { width: 68, height: 68 },
          lazyload: false,
        })
      )
    )
  );
}

module.exports = Thumbnail;
